import { useEffect } from "react";

import { useConfig } from "../../core/config";
import { useAnalytics } from "../../lib/analytics/analytics";
import { makeHotjarClient } from "../../lib/analytics/hotjar";
import { makeMixpanelClient } from "../../lib/analytics/mixpanel";
import { makeGA4Client } from "../../lib/analytics/ga4";

export function useCMDashboardAnalytics() {
  const config = useConfig();
  const analytics = useAnalytics();

  useEffect(() => {
    const variables = envVariables[config.environment];

    // Google Analytics
    if (variables.ga4TrackingId) {
      const ga4Client = makeGA4Client({
        trackingId: variables.ga4TrackingId,
        gaOptions: {
          name: "cmdashboard",
        },
      });

      analytics.addClient(ga4Client);
    }

    // Hotjar
    if (variables.hotjarId && variables.hotjarSnippetVersion) {
      const hotjarClient = makeHotjarClient({
        hotjarTrackingID: variables.hotjarId,
        hotjarSnippetVersion: variables.hotjarSnippetVersion,
      });

      analytics.addClient(hotjarClient);
    }

    // Mixpanel
    if (!!variables.mixpanelToken) {
      const mixpanelClient = makeMixpanelClient({
        token: variables.mixpanelToken,
        debug: variables.debug,
      });

      analytics.addClient(mixpanelClient);
    }
  }, [analytics, config.environment]);
}

const envVariables = {
  development: {
    ga4TrackingId: "",
    mixpanelToken: "",
    hotjarId: null,
    hotjarSnippetVersion: null,
    debug: true,
  },
  staging: {
    ga4TrackingId: "G-DXMJ6H596S",
    mixpanelToken: "b7487d3cc00c9abcb63dc96a73b5aa84",
    hotjarId: 2005679,
    hotjarSnippetVersion: 6,
    debug: true,
  },
  production: {
    ga4TrackingId: "G-RNW5MWPDD5",
    mixpanelToken: "da82f2cd77ab98632a71d91480e3a53d",
    hotjarId: 2003465,
    hotjarSnippetVersion: 6,
    debug: false,
  },
};
